import { createRouteRef } from '@backstage/core-plugin-api';

export const okrCascadeRouteRef = createRouteRef({
  id: 'okr-cascade',
});
